"use client";

// ../../utilities/dom-animation/src/index.ts
import { domAnimation } from "framer-motion";
var src_default = domAnimation;
export {
  src_default as default
};
